import {SetCredentialsRequest} from './set-credentials-request.model';

export class SetCredentialsOldPasswordRequest extends SetCredentialsRequest {
    oldPassword: string;

    constructor(obj: any = {}) {
        super(obj);
        this.oldPassword = obj && obj.oldPassword || null;
    }
}